import { render, staticRenderFns } from "./IndexFooter.vue?vue&type=template&id=6586c797&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"
import style0 from "./IndexFooter.vue?vue&type=style&index=0&id=6586c797&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586c797",
  null
  
)

export default component.exports